<template>
<div>
<div v-if='categories&&categories.length' >
        <div  v-for="(category,index) in categories" :key="index">
            <li class="option" @click.stop="select(category)">{{ $translation(category.name) }}</li>
            <div style="margin-left:20px">
                <TMultiselectTree @select='select' :categories="category.children"/>
            </div>
        </div>
    </div>
</div>
</template>


<script>
import TMultiselectTree from "./TMultiselectTree.vue"

export default {
    components:{TMultiselectTree},
    data(){
        return {

        }
    },
    methods:{
        select(category)
        {
            let object = {}
            object.name = category.name
            object.value = category.name
            
            if(category.id)
            {
                object.value = category.id
                object.id = category.id
            }

            this.$emit('select',object)
        }
    }, 
    emits:['select'],
    props:{
        categories: [],
    },
       
}
</script>

<style lang='scss' scoped>
    .option
    {
        cursor: pointer;
        list-style-type: none;
    }

    .option:hover{
        background-color: lightgray;
    }
</style>